import "./bootstrap";
import "./mobileVh";
import Vue from "vue";

import Vue2TouchEvents from "vue2-touch-events"; //for mobile swipe, tap, etc. https://github.com/jerrybendy/vue-touch-events
import VueCtkDateTimePicker from "vue-ctk-date-time-picker"; //date time picker
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import AWN from "awesome-notifications";
import "awesome-notifications/dist/style.css";
import vuetify from "./plugins/vuetify"; // path to vuetify export
import './plugins/dayjs';

//Import shared components
import Sidebar from "./components/shared/sidebar/Sidebar";
import SidebarElement from "./components/shared/sidebar/SidebarElement";
import SidebarOpener from "./components/shared/navbar/SidebarOpener";

// Import filters
import "./filters/round";
import "./filters/toCurrency";
// import "./directives/clickOutside";
import "./directives/tooltip";

//setup Vue
Vue.prototype.$http = window.axios;
Vue.use(Vue2TouchEvents); //mobile swiping
// Vue.component("v-select", vSelect); //vue-select

import Ads from 'vue-google-adsense'
Vue.use(require('vue-script2'))
Vue.use(Ads.Adsense)
Vue.use(Ads.InFeedAdsense)

import AdManager from 'google-ad-manager-vue';
let mappings = {
	banner:[
		{ window :[0,0], sizes: [ [320,50] ] },
		{ window :[980,0], sizes: [ [720,60],[728,90] ] }
	],
	rectangle:[
		{ window: [0, 0], sizes: [ [300, 250] ] },
        { window: [980, 0], sizes: [ [300, 250] ] }
	]
}

Vue.use(AdManager, {
  id: '21824466116',
  mappings,
});

// text highlighting component
import TextHighlight from 'vue-text-highlight';
Vue.component('text-highlight', TextHighlight);

Vue.mixin({
  data: function () {
    return {
      lang: function () {
        return window.Lang;
      },
    };
  },
});

Vue.prototype.$notify = new AWN({ position: "top-right" });

//Import Admin Components
import PageAlerts from "./components/admin/PageAlerts";

import SortingCard from "./components/admin/cards/SortingCard";
import PostingQueueCard from "./components/admin/cards/PostingQueueCard";
import StatAverages from "./components/admin/cards/StatAverages";
import TopAdminsCard from "./components/admin/cards/TopAdminsCard";
import TopPostsCard from "./components/admin/cards/TopPostsCard";
import PageLikes from "./components/admin/cards/PageLikes";
import LinkedPages from "./components/admin/cards/LinkedPages";
import AcceptanceRatioChart from "./components/admin/cards/AcceptanceRatioChart";

import Bulletins from "./components/admin/bulletins/Bulletins";
import NewBulletin from "./components/admin/bulletins/NewBulletin";
import NewBulletinModal from "./components/admin/bulletins/NewBulletinModal";

import SortingList from "./components/admin/sorting/SortingList";
import PostingList from "./components/admin/postinglist/PostingList";

import EditSubmissionPopup from "./components/admin/EditSubmissionPopup";
import MoveSubmissionPagePopup from "./components/admin/MoveSubmissionPagePopup";

import AdminActionsTable from './components/admin/details/AdminActionsTable';
import ArchiveRoot from './components/admin/archive/ArchiveRoot';
import SubmissionCardContainer from './components/admin/details/SubmissionCardContainer';

import AdminTools from './components/admin/tools/AdminTools';
import MassDismissCard from './components/admin/tools/MassDismissCard';

import PostTemplatePreview from "./components/admin/settings/PostTemplatePreview";

//Admin buses
window.BulletinEventBus = new Vue();
window.SidebarEventBus = new Vue();

//Admin vue holder
new Vue({
    el: '#admin-vue-root',
    vuetify,
    components: {
        Sidebar,
        SidebarElement,
        SidebarOpener,
        PageAlerts,

        SortingCard,
        PostingQueueCard,
        StatAverages,
        TopAdminsCard,
        TopPostsCard,
        PageLikes,
        LinkedPages,
        AcceptanceRatioChart,
        SubmissionCardContainer,

        Bulletins,
        NewBulletin,
        NewBulletinModal,

        SortingList,
        PostingList,

        EditSubmissionPopup,
        MoveSubmissionPagePopup,

        AdminActionsTable,
        ArchiveRoot,

        AdminTools,
        MassDismissCard,

        PostTemplatePreview,
    }
});

Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);
import developerDashboard from './components/developer/developerDashboard';
import usersTable from './components/developer/usersTable';
import hallOfFameGroupsList from './components/developer/hallOfFame/hallOfFameGroupsList';
import pagesTable from './components/developer/pagesTable';
import pageDetails from './components/developer/pageDetails';
import suggestedPost from './components/developer/suggestedPost';

//developer vue holder
new Vue({
  el: "#developer-vue-root",
  vuetify,
  components: {
    Sidebar,
    SidebarElement,
    SidebarOpener,
    developerDashboard,
    usersTable,
    hallOfFameGroupsList,
    pagesTable,
    pageDetails,
    suggestedPost,
  },
});

import registration from "./components/registration/registration";
import login from "./components/login/login";
import initialFormCreation from "./components/initialFormCreation/initialFormCreation";
import forgotPassword from "./components/forgotPassword/forgotPassword";
import submitted from "./components/submission/submitted";
import SubmissionTrackersList from './components/submitPage/SubmissionTrackersList';
import helpCentre from './components/helpCentre/helpCentre';
import helpCentreCategory from './components/helpCentre/helpCentreCategory';
import hallOfFamePage from './components/hallOfFame/hallOfFamePage';
import hallOfFameHome from './components/hallOfFame/hallOfFameHome';
import hallOfFamePost from './components/hallOfFame/components/hallOfFamePost';
import siteDocCard from './components/siteDocs/siteDocCard';

new Vue({
  el: "#vue-root",
  vuetify,
  components: {
    registration,
    login,
    initialFormCreation,
    forgotPassword,
    submitted,
    SubmissionTrackersList,
    helpCentre,
    helpCentreCategory,
    hallOfFamePage,
    hallOfFameHome,
    hallOfFamePost,
    siteDocCard,
  },
});
